// extracted by mini-css-extract-plugin
export default {"brandText":"informativeText_brandText__QnnSJ","bodyText":"informativeText_bodyText__-5mJ3","slideTransition":"informativeText_slideTransition__2KJv5"};